import { formatDateTimeReadable } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export const updatedAtWithBorrowerAndMerchantNameMobileFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.7,
    field: 'updated_at',
    headerName: <Text tId={'UPDATE_DATE'} />,
    align: 'left',
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData) => {
      return (
        <div className={'overflow-text-ellipsis'}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Font color="textPrimary" variant="caption" style={{ lineHeight: '1.43rem' }}>
              <strong>{formatDateTimeReadable(rowData.row.updatedAt)}</strong>
            </Font>
          </div>
          <div>
            <Font color="textSecondary" variant={'body2'}>
              {rowData.row.borrower.fullName.firstName} {rowData.row.borrower.fullName.lastName}
            </Font>
          </div>
          <div className={'overflow-text-ellipsis'}>
            <Font color="textSecondary" variant={'caption'}>
              {rowData.row.businessName}
            </Font>
          </div>
        </div>
      );
    },
  };
};
